<script setup>
import {
  ref, reactive, nextTick, computed,
} from 'vue';
import { isEmpty } from 'lodash';

const props = defineProps({
  referencias: { type: Array, default: () => [] },
  inputName: { type: String, required: true },
  disabled: { type: Boolean, default: false },
});

const localReferencias = reactive([...props.referencias]);
const lineaReferencia = ref(null);

function agregarReferencia() {
  localReferencias.push('');
  nextTick(() => {
    lineaReferencia.value[localReferencias.length - 1].focus();
  });
}

function eliminarReferencia(index) {
  if (index < 0) { return; }
  localReferencias.splice(index, 1);
}

const referenciasNoVacias = computed(() => localReferencias.filter((r) => !isEmpty(r)));
</script>

<template>
  <template v-if="!disabled">
    <table class="table m-b-none">
      <thead>
        <tr>
          <th></th>
          <th class="col-min">
            <button
              type="button"
              class="btn btn-cifra btn-xs"
              @click="agregarReferencia"
            >
              <i class="fa fa-plus"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(_referencia, index) in localReferencias" :key="index">
          <td>
            <input ref="lineaReferencia" v-model="localReferencias[index]" class="form-control">
          </td>
          <td class="acciones-celda">
            <i
              class="fa fa-trash text-danger clickable"
              @click="eliminarReferencia(index)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Sentinel: ensures the param is sent even with empty array, model strips blanks -->
    <input type="hidden" :name="inputName" value="" />
    <input
      v-for="(referencia, i) in referenciasNoVacias"
      :key="i"
      type="hidden"
      :name="inputName"
      :value="referencia"
    />
  </template>
  <template v-else>
    <table class="table m-b-none">
      <thead>
        <tr>
          <th>{{ $I18n.t('activerecord.attributes.diversidad.referencias') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(referencia, i) in localReferencias" :key="i">
          <td>{{ referencia }}</td>
        </tr>
      </tbody>
    </table>
  </template>
</template>

<style scoped>
table > tbody > tr > td {
  vertical-align: middle;
}

table > tbody > tr > td.acciones-celda {
  text-align: center;
  white-space: nowrap;
}
</style>
